// extracted by mini-css-extract-plugin
export var createdDate = "_md-1";
export var divider = "_md-2";
export var headerDivider = "_md-3";
export var messagesCard = "_md-0";
export var messagesContainer = "_md-6";
export var messagesContainerWrapper = "_md-4";
export var showLeftPanelButton = "_md-8";
export var topButtons = "_md-7";
export var withPadding = "_md-5";